// Shared by the public Lake Como card renderer and admin visibility reporting.
// A placement is only publicly visible when its compiled snapshot is renderable
// and falls within the page's deliberate card limit.

export type LakeComoCommercialSnapshot = {
  id?: unknown;
  placement_id?: unknown;
  title?: unknown;
  url?: unknown;
  placement?: unknown;
};

const pageCardLimits: Record<string, number> = {
  // The mobility hub is a compact next-step rail, not a commercial catalogue.
  "lake-como/getting-around": 3,
  "lake-como/milan-to-bellagio": 2,
};

export function lakeComoCommercialCardLimit(pageKey: string, explicitLimit?: number): number | null {
  if (typeof explicitLimit === "number") return Math.max(0, explicitLimit);
  return pageCardLimits[pageKey] ?? null;
}

export function isRenderableLakeComoCommercialCard(card: LakeComoCommercialSnapshot): boolean {
  const title = typeof card?.title === "string" ? card.title.trim() : "";
  const url = typeof card?.url === "string" ? card.url.trim() : "";
  const placement = typeof card?.placement === "string" ? card.placement : "general";
  return Boolean(title && /^https:\/\//i.test(url) && (placement === "general" || !placement));
}

export function resolveVisibleLakeComoCommercialCards<T extends LakeComoCommercialSnapshot>(
  cards: readonly T[] | null | undefined,
  pageKey: string,
  explicitLimit?: number,
): T[] {
  const renderable = Array.isArray(cards) ? cards.filter(isRenderableLakeComoCommercialCard) : [];
  const limit = lakeComoCommercialCardLimit(pageKey, explicitLimit);
  return limit === null ? renderable : renderable.slice(0, limit);
}

export function lakeComoCommercialVisibilityDetail(pageKey: string): string | null {
  const limit = lakeComoCommercialCardLimit(pageKey);
  return limit === null ? null : `This page intentionally displays the first ${limit} published card${limit === 1 ? "" : "s"}.`;
}
